import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { FilterPanel } from '../../../generic/Filter';
import RadioFilterGroup from '../../../generic/Filter/RadioFilterGroup';
import type { RadioFilterOption } from '../../../generic/Filter/RadioFilterGroup';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import { FilterKeys } from '../../../../../shared/projectsV2';

const FILTER_OPTIONS: RadioFilterOption[] = [
  { label: 'Anytime', value: 'any' },
  { label: 'Last 7 days', value: '7' },
  { label: 'Last 30 days', value: '30' },
  { label: 'Last 120 days', value: '120' },
];
const DEFAULT_VALUE: string = 'any';

const ageToValue = (age?: number): string => {
  if (age === undefined) {
    return 'any';
  }
  return String(age);
};

const Scanned: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter);
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  const onSelect = (value: string) => {
    if (Number(value)) {
      setFilter({ ...filter, [FilterKeys.LatestScan]: Number(value) });
    } else {
      setFilter({ ...filter, [FilterKeys.LatestScan]: undefined });
    }
  };

  return (
    <FilterPanel>
      <RadioFilterGroup
        title="Last policy scan"
        options={FILTER_OPTIONS}
        value={ageToValue(filter.latestScan)}
        defaultValue={DEFAULT_VALUE}
        onSelect={onSelect}
      />
    </FilterPanel>
  );
};

export default Scanned;
